import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Modal } from 'antd';
import { rejectComplianceRequestInstance } from '../../thunks/compliance_request_instances_thunks';
import { withUserType } from '../withUserType';
import { ComplianceRequestInstance } from '../../types/ComplianceTypes';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface RejectComplianceInstanceModalProps {
	visible: boolean;
	// Falls back to the logged-in user's role (session.userType, injected by
	// withUserType) when not explicitly provided.
	roleType?: string;
	instance: ComplianceRequestInstance;
	onCancel: () => void;
	onSuccess: () => void;
	rejecting: boolean;
	rejectInstance: (id: number, body: any) => Promise<any>;
}

const RejectComplianceInstanceModal: FC<RejectComplianceInstanceModalProps> = ({
	visible,
	instance,
	onCancel,
	onSuccess,
	rejecting,
	rejectInstance,
}): React.ReactElement => {
	const [form] = Form.useForm();

	const handleSubmit = () => {
		form.validateFields().then((values) => {
			rejectInstance(instance.id, { rejectionReason: values.rejectionReason }).then(onSuccess);
		});
	};

	const supplierName = nullSafeGetOrElse('supplierFacility.name', instance, 'this supplier');
	const requestName = nullSafeGetOrElse('complianceRequest.name', instance, 'this request');

	return (
		<Modal
			visible={visible}
			title="Reject Compliance Document"
			okText="REJECT"
			okType="danger"
			cancelText="CANCEL"
			onOk={handleSubmit}
			onCancel={onCancel}
			confirmLoading={rejecting}
			destroyOnClose={true}
		>
			<div className="mb-4 text-character-secondary">
				Rejecting {supplierName}'s submission for "{requestName}". The supplier will be asked to
				submit a new document.
			</div>
			<Form form={form} layout="vertical" preserve={false}>
				<Form.Item
					name="rejectionReason"
					label="Reason"
					rules={[{ required: true, message: 'Please explain why this document is rejected.' }]}
				>
					<Input.TextArea rows={3} placeholder="e.g. document expired, wrong coverage amount" />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	rejecting: state.compliance_request_instances.updating,
});

const mapDispatchToProps = (dispatch, ownProps) => {
	const role = ownProps.roleType || ownProps.userType;
	return {
		rejectInstance: (id, body) => dispatch(rejectComplianceRequestInstance(role)(id, body)),
	};
};

export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(RejectComplianceInstanceModal)
);
